import Colors from "constants/Colors";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ClipLoader } from "react-spinners";
import "./Loader.scss";

interface Props {
  isLoading: boolean;
}

export const Loader: FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="LoaderContainer">
      <ClipLoader loading={props.isLoading} color={Colors.brand.blue} />
      <div className="LoaderText">{t("loading")}</div>
    </div>
  );
};
